import { HelpCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

export const TERMS = {
  BAS: 'Business Activity Statement – a form businesses lodge with the ATO (monthly, quarterly or yearly) to report GST, PAYG withholding and PAYG instalments.',
  IAS: 'Instalment Activity Statement – like a BAS, but only for PAYG instalments or withholding, for people and businesses not registered for GST.',
  'taxable income': 'Your total assessable income minus allowable deductions. Tax is worked out on this amount.',
  depreciation: 'Spreading the cost of an asset (like a rental property’s fittings) over its useful life, so part of the cost is claimed as a deduction each year.',
  FY: 'Financial year – in Australia it runs from 1 July to 30 June. "2025–26" means 1 July 2025 to 30 June 2026.',
};

// Short plain-language explanation for tax terms. Keyboard focusable, screen-reader labelled.
export const HelpTip = ({ term, children }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" className="inline-flex items-center gap-1 align-middle rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label={`What is ${term}?`} data-testid={`help-${term.replace(/\s+/g, '-').toLowerCase()}`}>
          {children}
          <HelpCircle className="w-3.5 h-3.5 text-muted-foreground" aria-hidden="true" />
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs text-xs leading-relaxed">{TERMS[term]}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
